import gql from 'graphql-tag';

export default gql`
query QueryMyLeases {
    queryMyLeases {
      items {
        __typename
        uuids
        type
        created
        accessed
        cntr
        expires
        endpointsCompleted
        completed

        app {
          __typename
          uuid
          data
        }
      }
    }
}
`;
